
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/heart-one",
      function () {
        return require("private-next-pages/cases/heart-one/index.tsx");
      }
    ]);
  